<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div>
      <el-button type="primary" @click="onClickAdd">新建</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="name" label="活动名称"></el-table-column>
      <el-table-column label="生效时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.startTime) }} ~ {{ dateFormat(scope.row.endTime) }}
        </template>
      </el-table-column>
      <el-table-column label="编辑">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">编辑</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="操作时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.updatedAt) }}
        </template>
      </el-table-column>
      <el-table-column prop="updatedBy" label="操作人"></el-table-column>
    </el-table>

    <el-dialog append-to-body :title="form.id ? '编辑' : '新建'" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="活动名称" required>
          <el-input v-model.trim="form.name"></el-input>
        </el-form-item>
        <el-form-item label="生效时间" required>
          <el-date-picker
            v-model="daterange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="timestamp"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="弹窗频次" required>
          <el-select v-model="form.popPolicy" placeholder="请选择">
            <el-option label="一天弹一次" :value="0"></el-option>
            <el-option label="只弹一次" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指定页面" required>
          <el-select v-model="form.tab" placeholder="请选择">
            <el-option label="个人中心" :value="0"></el-option>
            <el-option label="卖货" :value="1"></el-option>
            <el-option label="spu详情" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指定公告">
          <el-select v-model="form.routingUrl" filterable clearable placeholder="请选择">
            <el-option v-for="item in noticeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="弹窗图片" required>
          <div class="upload-btn">
            <img v-if="form.bannerUrl" class="tag-img" :src="form.bannerUrl" alt="">
            <el-button v-else type="primary" icon="el-icon-upload" size="mini" plain>选择图片</el-button>
            <input @change="changeFile" accept=".jpg,.jpeg,.png" type="file" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/util';
import Client from "@/utils/client.js";
import { fileUpload } from '../../api/merchants';
import {
  getSellerCampaignPopoverList,
  getSellerCampaignPopover,
  saveSellerCampaignPopover,
  getSellerNoticeList,
} from "./api";

export default {
  data() {
    return {
      fullscreenLoading: false,
      tableData: [],
      noticeList: [],
      dialogVisible: false,
      daterange: [],
      form: {
        id: null,
        name: null,
        bannerUrl: null,
        popoverId: null,
        popPolicy: null,
        tab: null,
        routingUrl: null,
      },
      formLoading: false,
    };
  },
  created() {
    getSellerNoticeList().then(res => {
      if (res.data && res.data.data) {
        this.noticeList = res.data.data;
      }
    })
    this.getTableData();
  },
  methods: {
    getTableData() {
      getSellerCampaignPopoverList().then(res => {
        if (res.data && res.data.data) {
          this.tableData = res.data.data;
        }
      })
    },
    onClickAdd() {
      this.form.id = null;
      this.form.name = null;
      this.form.bannerUrl = null;
      this.form.popoverId = null;
      this.form.popPolicy = null;
      this.form.tab = null;
      this.form.routingUrl = null;
      this.daterange = [];
      this.dialogVisible = true;
    },
    editItem(row) {
      this.form.id = null;
      this.form.name = null;
      this.form.bannerUrl = null;
      this.form.popoverId = null;
      this.form.popPolicy = null;
      this.form.tab = null;
      this.form.routingUrl = null;
      this.daterange = [];
      this.formLoading = true;
      this.dialogVisible = true;
      getSellerCampaignPopover(row.id).then(res => {
        if (res.data && res.data.data) {
          this.form.id = res.data.data.id;
          this.form.name = res.data.data.name;
          this.form.bannerUrl = res.data.data.bannerUrl;
          this.form.popoverId = res.data.data.popoverPolicies[0].id;
          this.form.popPolicy = res.data.data.popoverPolicies[0].popPolicy;
          this.form.tab = res.data.data.popoverPolicies[0].tab;
          if (res.data.data.popoverPolicies[0].routingUrl) {
            this.form.routingUrl = res.data.data.popoverPolicies[0].routingUrl * 1;
          }
          this.daterange = [res.data.data.startTime, res.data.data.endTime];
        }
        this.formLoading = false;
      })
    },
    async changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.(png|jpe?g)(\?.*)?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.jpg .jpeg .png格式');
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件太大了');
          return;
        }
        this.fullscreenLoading = true;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const fileName = this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
        const random_name = 'tmp/' + fileName;
        const res = await OSSClient.put(random_name, file);
        this.form.bannerUrl = res.url;
        this.fullscreenLoading = false;
      }
      e.target.value = '';
    },
    random_string(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    submit() {
      if (!this.form.name) {
        this.$message.error('请输入活动名称');
        return;
      }
      if (!this.daterange || this.daterange.length === 0) {
        this.$message.error('请选择生效时间');
        return;
      }
      if (this.form.popPolicy === null) {
        this.$message.error('请选择弹窗频次');
        return;
      }
      if (this.form.tab === null) {
        this.$message.error('请选择指定页面');
        return;
      }
      if (!this.form.bannerUrl) {
        this.$message.error('请上传弹窗图片');
        return;
      }
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      saveSellerCampaignPopover({
        id: this.form.id,
        name: this.form.name,
        bannerUrl: this.form.bannerUrl,
        popoverPolicies: [{
          id: this.form.popoverId,
          popPolicy: this.form.popPolicy,
          tab: this.form.tab,
          routingUrl: this.form.routingUrl,
        }],
        startTime: this.daterange[0] || null,
        endTime: this.daterange[1] || null,
      }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '保存失败');
        }
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 1000)
      }).catch(err => {
        this.repeatSubmit = false;
      })
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.status-point {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 3px;
  background-color: #F56C6C;
  border-radius: 6px;

  &.green {
    background-color: #67C23A;
  }
  &.gray {
    background-color: #909399;
  }
}
.upload-btn {
  display: inline-block;
  position: relative;
  margin-right: 50px;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}
.tag-img {
  display: block;
  max-width: 100%;
}
</style>
